import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserPlusIcon, XIcon } from 'lucide-react';
interface FirstLoginModalProps {
  onClose: () => void;
}
const FirstLoginModal: React.FC<FirstLoginModalProps> = ({
  onClose
}) => {
  const navigate = useNavigate();
  const handleAddBuddy = () => {
    navigate('/settings');
    onClose();
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-id="element-125">
      <div className="bg-white rounded-xl w-full max-w-md" data-id="element-126">
        <div className="p-6" data-id="element-127">
          <div className="flex justify-between items-start mb-4" data-id="element-128">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-129">
              <UserPlusIcon size={24} className="text-purple-600" data-id="element-130" />
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-131">
              <XIcon size={20} data-id="element-132" />
            </button>
          </div>
          <h2 className="text-xl font-semibold mb-2" data-id="element-133">
            Want support sticking with your goals?
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-134">
            Add a trusted friend to help you stay on track. We'll send them a
            few kind text nudges, with both of your permission.
          </p>
          <div className="space-y-3" data-id="element-135">
            <button onClick={handleAddBuddy} className="w-full px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700" data-id="element-136">
              Add a Support Buddy
            </button>
            <button onClick={onClose} className="w-full px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg" data-id="element-137">
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default FirstLoginModal;